import { GrupoclienteService } from 'app/service/cliente/grupocliente.service';
import { ClientesComponent } from './../clientes.component';
import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import { TipoReajusteModel } from 'app/model/cliente/tiporeajuste.model';
import { IndiceReajusteModel } from 'app/model/cliente/indicereajuste.model';
import { GrupoClienteModel } from 'app/model/cliente/grupocliente.model';
import { RamoAtividadeModel } from 'app/model/cliente/ramoatividade.model';
import { PrecoModel } from 'app/model/produto/preco.model';
import { AreaModel } from 'app/model/cliente/area.model';
import { TipoClienteModel } from 'app/model/cliente/tipocliente.model';
import { ProdutoModel } from './../../../../model/produto/produto.model';
import { ClienteModel } from 'app/model/cliente/cliente.model';
import { PrecoService } from './../../../../service/produto/preco.service';
import { ProdutoService } from './../../../../service/produto/produto.service';
import { MatDialog } from '@angular/material/dialog';
import { AreaService } from 'app/service/cliente/area.service';
import * as CryptoJS from 'crypto-js';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import { ClienteService } from 'app/service/cliente/cliente.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@alfresco/adf-core';
import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  TemplateRef,
  Input,
  EventEmitter,
  SimpleChanges,
  OnChanges
} from '@angular/core';

@Component({
  selector: 'app-create-cliente',
  templateUrl: './create-cliente.component.html',
  styleUrls: ['./create-cliente.component.scss'],
})
export class CreateClienteComponent implements OnInit {
  maskCpf = [
    /\d/,
    /\d/,
    /\d/,
    '.',
    /\d/,
    /\d/,
    /\d/,
    '.',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
  ];

  //19.045.470/0001-08
  maskCnpj = [
    /\d/,
    /\d/,
    '.',
    /\d/,
    /\d/,
    /\d/,
    '.',
    /\d/,
    /\d/,
    /\d/,
    '/',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
  ];

  queryField = new FormControl();

  @ViewChild('closeModal') closeModal: ElementRef;
  @ViewChild('content') private contentRef: TemplateRef<Object>;
  @ViewChild('enderecoArea') enderecoArea: ElementRef;
  item = '';

  precoModal = false;
  editPreco = false;
  edit = false;
  editShow = false;

  public submit = false;

  EhNovoCliente = false;

  @Input() clienteProp: ClienteModel;

  public clienteForm: FormGroup;
  public precoForm: FormGroup;

  produto = {} as ProdutoModel;
  produtos: ProdutoModel[];

  cliente = {} as ClienteModel;
  clientes: ClienteModel[];

  tipoCliente = {} as TipoClienteModel;
  tipoClientes: TipoClienteModel[];

  area = {} as AreaModel;
  areas: AreaModel[];

  precoPadraoPorProduto = {} as PrecoModel;

  ramoAtividade = {} as RamoAtividadeModel;
  ramoAtividades: RamoAtividadeModel[];

  grupoCliente = {} as GrupoClienteModel;
  grupoClientes: GrupoClienteModel[];

  indiceReajuste = {} as IndiceReajusteModel;
  indiceReajustes: IndiceReajusteModel[];

  tipoReajuste = {} as TipoReajusteModel;
  tipoReajustes: TipoReajusteModel[];

  public page: ResponsePageable;

  public pageProduto: ResponsePageable;

  selectedMovimentacao: boolean = false;
  selectedTransporte: boolean = false;

  public pageAtual = 0;

  public novo = false;

  public selectedValue = 0;

  public edited = false;
  public editado = false;
  public errorAlert = false;
  public successDelete = false;

  progress: boolean = false;

  public clienteId: any;

  public idNovoCliente;
  public novoCliente: ClienteModel;

  public deData: any;

  public idEmpresa: any;
  public clienteIdCrypt: any;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  adm = true;
  acervo = false;
  solicitacao = false;

  public loading = true;

  constructor(
    public clienteService: ClienteService,
    public grupoClienteService: GrupoclienteService,
    private fb: FormBuilder,
    private areaService: AreaService,
    public dialog: MatDialog,
    private produtoService: ProdutoService,
    private precoService: PrecoService,
    private authService: AuthenticationService,
    private router: Router,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute
  ) {
    if (this.route.params !== null) {
      this.route.params.subscribe(params => this.clienteId = params['id']);
      this.route.params.subscribe(params => this.clienteIdCrypt = params['id']);
      this.deData = CryptoJS.AES.decrypt(decodeURIComponent(this.clienteId), 'pcdoc');
      this.clienteId = JSON.parse(this.deData.toString(CryptoJS.enc.Utf8));
    }
  }

  ngOnInit() {
    this.clienteForm = this.fb.group({
      nome: ['', [Validators.maxLength(80)]],
      selectedValue: [null],
      cpf: ['', [Validators.required]],
      email: ['', [Validators.required]],
      nomeFantasia: ['', [Validators.maxLength(80)]],
      responsavel: ['', [Validators.maxLength(80)]],
      inscricaoEstadual: ['', [Validators.maxLength(80)]],
      inscricaoMunicipal: ['', [Validators.maxLength(80)]],
      observacao: ['', [Validators.maxLength(255)]],
      dataReajuste: ['', [Validators.required]],
      tipoClientes: ['', [Validators.required]],
      ramoAtividade: [RamoAtividadeModel, [Validators.required]],
      grupoCliente: [GrupoClienteModel, [Validators.required]],
      indiceReajuste: [IndiceReajusteModel, [Validators.required]],
      tipoReajuste: [TipoReajusteModel, [Validators.required]],
      tipoCliente: [TipoClienteModel, [Validators.required]],
      area: [[AreaModel], [Validators.required]],
    });

    this.precoForm = this.fb.group({
      utilizacao: ['', Validators.required],
      armazenagem: ['', Validators.required],
      movImplantacao: ['', Validators.required],
      movEntrada: ['', Validators.required],
      movSaidaNormal: ['', Validators.required],
      movSaidaUrgente: ['', Validators.required],
      transImplantacao: ['', Validators.required],
      transEntrada: ['', Validators.required],
      transSaidaNormal: ['', Validators.required],
      transSaidaUrgente: ['', Validators.required],
      selectedMovimentacao: [false],
      selectedTransporte: [false],
    });

    this.getTipoCliente();
    this.getIndiceReajuste();
    this.getGrupoCliente();
    this.getRamoAtividade();
    this.getTipoReajuste();
    this.listPageProdutos(0, 10);
    this.getClienteUnico(this.clienteId);
  }

  getIdEmpresa(id: number) {
    this.idEmpresa = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(id), 'pcdoc').toString());
    this.router.navigate(['/cliente', this.idEmpresa]);
  }

  addItem(newItem: string) {
    this.item = newItem;
    this.enderecoArea.nativeElement.click();
  }

  getPrecoPadrao(id: number) {
    this.precoService.getPrecoPadraoPorProduto(id).subscribe((data) => {
      this.precoPadraoPorProduto = data;
    });
  }

  tabClick(event) {

  }

  getDadosEditPreco(preco: PrecoModel) {
    this.precoPadraoPorProduto = { ...preco };
    this.editPreco = true;
    this.edit = true;
    this.editShow = true;
    this.selectedMovimentacao = true;
    this.selectedTransporte = true;
  }

  showModal() {
    this.precoModal = true;
    this.precoPadraoPorProduto;
  }

  onSearch() {
    let value = this.queryField.value;
    if (value && value.trim() !== '') {
      value = value.trim();
    }
  }

  listPageProdutos(page, size) {
    this.produtoService.getPageProduto(page, size).subscribe((data) => {
      this.pageProduto = data;
      this.produtos = this.pageProduto.content;
    });
  }

  adicionarProduto(produto: ProdutoModel, idCliente: number) {
    this.produtoService.adicionarProduto(produto, idCliente).subscribe(
      (data) => {
      },
      (error) => {
        console.error(error);
      }
    );
  }

  getDadosAddProduto(cliente: ClienteModel) {
    this.cliente = { ...cliente };
  }

  getDadosAddProduto2(cliente: ClienteModel, produto: ProdutoModel) {
    this.cliente = { ...cliente };
    this.produto = { ...produto };
  }

  getDados() {
    this.getTipoCliente();
    this.getGrupoCliente();
    this.getIndiceReajuste();
    this.getRamoAtividade();
    this.getTipoReajuste();
    this.postSubmit();
    this.setAreaClienteNull();
  }


  getClienteUnico(id: number) {
    this.clienteService.getClienteUnico(id).subscribe(data => {
      this.cliente = data;
      if (data.cpf.length === null) {
        this.clienteForm.get('selectedValue').setValue(1);
      }
      else if (data.cpf.length <= 14 ) {
        this.clienteForm.get('selectedValue').setValue(1);
      } else {
        this.clienteForm.get('selectedValue').setValue(2);
      }
      this.loading = false;
    }, error => {
      console.error(error);
      this.loading = false;
    });
  }

  openDialogCliente() {
    const dialogRef = this.dialog.open(ClientesComponent, {
      width: '100%',
    });
    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  listarPageClientes(page, size, nome) {
    this.clienteService.getPageClientes(page, size, nome).subscribe(res => {
      this.page = res;
      this.clientes = this.page.content;
    });
    this.progress = true;
  }

  changePage(event) {
    this.listarPageClientes(event.page, event.size, '');
    this.pageAtual = event.page;
  }

  onSubmit() {
    this.submit = true;
  }

  postSubmit() {
    this.submit = false;
    //this.clienteForm.reset();
    this.router.navigate(['/cliente', this.clienteIdCrypt]);
  }

  compararEditCliente(obj1, obj2) {
    return obj1 && obj2
      ? obj1.descricao === obj2.descricao && obj1.id === obj2.id
      : obj1 === obj2;
  }

  clickNovoCliente() {
    this.cliente.id = undefined;
    this.getDados();
  }

  saveOrEditCliente() {
    if (this.clienteId !== undefined) {
      this.EhNovoCliente = false;
      this.editarCliente();
    } else {
      this.EhNovoCliente = true;
      this.postCliente();
    }
  }

  // Editar Cliente
  editarCliente() {
    this.clienteService.putCliente(this.cliente).subscribe(
      (data) => {
        this.listarPageClientes(this.pageAtual, 10, '');
        this.openSnackBarSuccess('Cliente atualizado com sucesso !');
      },
      (err) => {
        console.log(err);
        this.openSnackBarError('Erro ao tentar atualizar o cliente !');
      }
    );
  }

  //Adicionar novo cliente
  postCliente() {
    this.clienteService.saveCliente(this.clienteForm.value).subscribe(
      (result) => {
        this.cliente = new ClienteModel();
        this.clienteForm.reset();
        this.openSnackBarSuccess('Cliente salvo com sucesso !');
        this.listarPageClientes(0, 10, '');
        this.idNovoCliente = this.cliente.id;
        this.novoCliente = this.cliente;
        this.router.navigate(['/editar-cliente/', result.id]);
        this.postSubmit();
      },
      function (error) {
        console.log(error);
        if (error.status == 400) {
          this.openSnackBarError('Este CPF ou CNPJ já está cadastrado !');
        }
      }
    );
  }

  getDadosEdit(cliente: ClienteModel) {
    this.cliente = { ...cliente };
    this.clienteForm.get('ramoAtividade').setValue(cliente.ramoAtividade);
    this.clienteForm.get('grupoCliente').setValue(cliente.grupoCliente);
    this.clienteForm.get('indiceReajuste').setValue(cliente.indiceReajuste);
    this.clienteForm.get('tipoReajuste').setValue(cliente.tipoReajuste);
    this.clienteForm.get('tipoCliente').setValue(cliente.tipoCliente);
    this.getAreasCliente(cliente.id);
  }

  confirmeExclusao(id: number) {
    var confirme = confirm('Tem certeza que deseja excluir este cliente ?');
    if (confirme == true) {
      this.apagarCliente(id);
    } else {
      console.log('Cancelou exclusão!');
    }
  }

  apagarCliente(id: number) {
    this.clienteService.deleteCliente(id).subscribe(
      (cliente) => {
        this.cliente = new ClienteModel();
        this.listarPageClientes(0, 10, '');
        this.openSnackBarSuccess('Cliente excluído com sucesso !');
        this.getPageArea(0, 2);
      },
      (error) => {
        console.log(error);
        this.openSnackBarError('Erro ao tentar excluir o cliente !');
      }
    );
  }

  getPageArea(page, size) {
    this.areaService.getPageAreas(page, size).subscribe((data) => {
      this.page = data;
      this.areas = this.page.content;
    });
  }

  getTipoCliente() {
    this.clienteService.getTipoCliente().subscribe((data) => {
      this.tipoClientes = data.content;
    });
  }

  getGrupoCliente() {
    this.grupoClienteService.getGruposClienteUsuarioNew().subscribe((data) => {
      this.grupoClientes = data.content;
    });
  }

  getRamoAtividade() {
    this.clienteService.getPageRamoAtividadeList().subscribe((data) => {
      this.ramoAtividades = data;
    });
  }

  getIndiceReajuste() {
    this.clienteService.getIndiceReajuste().subscribe((data) => {
      this.indiceReajustes = data.content;
    });
  }

  setAreaClienteNull() {
    this.areas = [];
  }

  getAreasCliente(id: number) {
    if (this.cliente.id !== undefined) {
      this.areaService.getAreasCliente(id).subscribe(
        (data) => {
          this.areas = data;
        },
        (err) => {
          console.log(err);
        }
      );
    } else {
      console.log('Novo cliente!');
    }
  }

  getTipoReajuste() {
    this.clienteService.getTipoReajuste().subscribe((data) => {
      this.tipoReajustes = data.content;
    });
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/cliente-components/clientes/create-cliente/create-cliente.component.ts